import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export function forbiddenPassword(min = 13, confirm?: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const pattern = Validators.pattern(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/)(control);
    const minL = Validators.minLength(min)(control);
    const same = confirm && (confirm.value !== control.value) && {value: false};
    return (pattern || minL || same) ? {pattern, minL, same} : null;
  };
}
